export default __webpack_public_path__ + "static/media/hht1_ep06_book_wp_02.c973ede3.jpg";